define([
    "./virtualFenceModule",
    "./virtualFenceService",
    "./virtualFenceController",
    "./virtualFenceRouter"
], function () {
});